import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

function hasJwt() {
  return !!Cookies.get('jwt');
}

function getExpirationTime() {
  const token = Cookies.get('jwt');
  if (!token) return 0;
  const decoded = jwtDecode(token);
  return decoded.exp;
}

function getPermission() {
  const token = Cookies.get('jwt');
  if (!token) return 3;
  const decoded = jwtDecode(token);
  return decoded.data.permission;
}

function getId() {
  const token = Cookies.get('jwt');
  if (!token) return 0;
  const decoded = jwtDecode(token);
  return decoded.data.id;
}

function resetJwt() {
  Cookies.remove('jwt');
}

export {
  hasJwt, getExpirationTime, getPermission, resetJwt, getId,
};
